/**
  Description:收货人地址添加页面
  Author:zcg
  Date:2020年03月31日15:19:05
**/
<template>

  <div class="edit-box">
    <!-- 输入任意文本-->
    <van-field v-model="addressInfo.name" label="收货人" />
    <van-field v-model="addressInfo.mobile" label="手机号" />
    <van-field v-model="uiAddressInfo" label="所在区域" readonly @click="showType = true" />
    <van-field v-model="addressInfo.address" label="详细地址" />
    <!-- <van-checkbox v-model="addressInfo.isDefault">设为默认</van-checkbox> -->
    <div class="default-address">
      <div class="default-text">设为默认地址</div>
      <van-switch v-model="addressInfo.isDefault" inactive-color="#BFBFBF" active-color="#07c160" size="22px" />
    </div>
    <van-popup v-model="showType" position="bottom">
      <!-- <van-area @change="onChangeDetail"  :area-list="areaList" />
       -->
      <div class="btn-content">
        <div class="btn-cancel" @click="showType= false">取消</div>
        <div class="btn-confirm" @click="onConfirm">确定</div>
      </div>
      <div class="picker-content">
        <van-picker :value="value1" :columns="areaList.province_list" @change="onChange1" />
        <van-picker :value="value2" :columns="areaList.city_list" @change="onChange2" />
        <van-picker :value="value3" :columns="areaList.county_list" @change="onChange3" />
      </div>
    </van-popup>
    <div class="save-btn-edit" @click="onSave">保存</div>
    <div class="delete-edit" v-if="addressInfo.name" @click="onDelect">删除收货地址</div>

  </div>

</template>





<script>
/**
 * 引用
 * */
import {
  addressSave,
  regionList,
  addressDetail,
  addressDelete,
} from "@/api/index";
import { Dialog } from "vant";
export default {
  data() {
    return {
      areaList: {
        province_list: ["请选择"],
        city_list: ["请选择"],
        county_list: ["请选择"],
      },
      areaListData: {
        province_list: [],
        city_list: [],
        county_list: [],
      },
      searchResult: [],
      addressInfo: {
        id: this.$route.query.id || 0, //地址id,新建时传0,编辑时传收货地址id
        name: "", //收货人
        mobile: "", //电话
        provinceId: "", //省份id
        cityId: "", //城市id
        areaId: "", //区域id
        address: "", //详细地址
        isDefault: true,
      },
      showType: false,
      value1: "",
      value2: "",
      value3: "",
      uiAddressInfo: "",
    };
  },
  mounted() {
    if (this.$route.query.id) {
      addressDetail(this.$route.query.id).then((res) => {
        if (res.data.errno == 0) {
          this.addressInfo = {
            id: res.data.data.id, //地址id,新建时传0,编辑时传收货地址id
            name: res.data.data.name, //收货人
            mobile: res.data.data.mobile, //电话
            provinceId: res.data.data.provinceId, //省份id
            cityId: res.data.data.cityId, //城市id
            areaId: res.data.data.areaId, //区域id
            address: res.data.data.address, //详细地址
            isDefault: res.data.data.isDefault,
          };
          this.uiAddressInfo = `${res.data.data.provinceName}/${res.data.data.cityName}/${res.data.data.areaName}`;
        }
      });
    }

    this.getAreaList(0);
  },
  methods: {
    onConfirm() {
      if (
        this.value1 == "" ||
        this.value2 == "" ||
        this.value3 == "" ||
        this.value1 == "请选择" ||
        this.value2 == "请选择" ||
        this.value3 == "请选择"
      ) {
        Dialog.alert({
          title: "提示",
          message: "请选择正确的地址",
        });
        return;
      }

      this.uiAddressInfo = `${this.value1}/${this.value2}/${this.value3}`;
      this.showType = false;
    },
    getProid(code) {
      return this.areaListData.province_list[code - 1].id;
    },
    onChange1(e, val, index) {
      this.value2 = "请选择";
      this.value3 = "请选择";
      if (index == 0) {
        this.value1 = val;
        // this.addressInfo.provinceId = this.getProid(index);
        this.areaList.county_list = ["请选择"];
        this.areaListData.county_list = ["请选择"];
        this.areaList.city_list = ["请选择"];
        this.areaListData.city_list = ["请选择"];
        return;
      }
      this.value1 = val;
      this.addressInfo.provinceId = this.getProid(index);
      this.areaList.county_list = ["请选择"];
      this.areaListData.county_list = ["请选择"];
      this.areaList.city_list = ["请选择"];
      this.areaListData.city_list = ["请选择"];
      this.getCityList(this.getProid(index));
    },
    getCityid(code) {
      return this.areaListData.city_list[code].id;
    },

    onChange2(e, val, index) {
      this.value2 = val;
      this.value3 = "请选择";
      this.addressInfo.cityId = this.getCityid(index);
      this.areaList.county_list = ["请选择"];
      this.areaListData.county_list = ["请选择"];
      if (this.addressInfo.cityId == undefined) {
        return;
      }
      this.getCountList(this.addressInfo.cityId);
    },
    getCountyid(code) {
      return this.areaListData.county_list[code].id;
    },
    onChange3(e, val, index) {
      this.addressInfo.areaId = this.getCountyid(index);
      this.value3 = val;
    },

    getAreaList(pid) {
      //获取省
      regionList(pid).then((res) => {
        res.data.data.forEach((element) => {
          if (element.type == 1) {
            this.areaList.province_list.push(element.name);

            this.areaListData.province_list.push(element);
          }
        });
      });
    },
    getCityList(pid) {
      console.log(pid);
      //获取市
      regionList(pid).then((res) => {
        this.areaList.city_list = ["请选择"];
        this.areaListData.city_list = ["请选择"];
        if (res.data.errno == 0) {
          res.data.data.forEach((element) => {
            if (element.type == 2) {
              this.areaList.city_list.push(element.name);
              this.areaListData.city_list.push(element);
            }
          });
        }
      });
    },
    getCountList(pid) {
      //获取区
      console.log(pid);
      regionList(pid).then((res) => {
        this.areaList.county_list = ["请选择"];
        this.areaListData.county_list = ["请选择"];
        if (res.data.errno == 0) {
          res.data.data.forEach((element) => {
            if (element.type == 3) {
              this.areaList.county_list.push(element.name);
              this.areaListData.county_list.push(element);
            }
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    onDelect() {
      Dialog.confirm({
        title: "提示",
        message: "确定要删除吗？",
      })
        .then(() => {
          // on confirm
          addressDelete(this.addressInfo.id).then((res) => {
            if (res.data.errno == 0) {
              this.$router.go(-1);
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    /**
     * 保存收货人地址
     * @param content
     */
    onSave() {
      // this.addressInfo = {
      //   id: 0, //地址id,新建时传0,编辑时传收货地址id
      //   name: content.name, //收货人
      //   mobile: content.tel, //电话
      //   provinceId: areaProvince, //省份id
      //   cityId: areaCity, //城市id
      //   areaId: areaCode, //区域id
      //   address: content.addressDetail, //详细地址
      //   isDefault: content.isDefault ? true : 0 //是否默认
      // };
      if (this.addressInfo.name == "") {
        Dialog.alert({
          title: "提示",
          message: "请填写收件人",
        });
        return;
      }
      if (this.addressInfo.mobile == "") {
        Dialog.alert({
          title: "提示",
          message: "请填写手机号码",
        });
        return;
      }
      if (this.addressInfo.mobile.length != 11) {
        Dialog.alert({
          title: "提示",
          message: "请正确填写手机号码",
        });
        return;
      }
      if (
        this.addressInfo.provinceId == "" ||
        this.addressInfo.cityId == "" ||
        this.addressInfo.areaId == ""
      ) {
        Dialog.alert({
          title: "提示",
          message: "请选择地址",
        });
        return;
      }
      if (this.addressInfo.address == "") {
        Dialog.alert({
          title: "提示",
          message: "请填写详细地址",
        });
        return;
      }
      Dialog.confirm({
        title: "提示",
        message: "确认新增地址？",
      })
        .then(() => {
          // on confirm
          this.addressInfo.isDefault
            ? (this.addressInfo.isDefault = true)
            : (this.addressInfo.isDefault = 0);
          addressSave(this.addressInfo).then((res) => {
            if (res.data.errno == 0) {
              console.log("确实是保存成功返回上一个页面了");
              this.$router.replace({
                path: "/selectAddress",
                query: {
                  cartId: sessionStorage.getItem("cartId"),
                },
              });
            } else {
              Dialog.alert({
                title: "提示",
                message: res.data.errmsg,
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>


<style scoped lang="scss">
.edit-box {
  background: #f4f4f4;
  height: 100%;
  .default-address {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 5rem;
    background: #fff;
    margin: 1rem 0;
    padding: 0 1.6rem;
    box-sizing: border-box;
    .default-text {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
    }
  }
  .van-cell {
    height: 5rem;
    display: flex;
    align-items: center;
    /deep/ .van-field__label {
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #424242;
      letter-spacing: 0;
      line-height: 1.4rem;
    }
  }
}

.btn-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 4rem;
  padding: 0 1rem;

  border: 1px solid #ebedf0;
  .btn-confirm,
  .btn-cancel {
    padding: 0 1.6rem;
    color: #1989fa;
    font-size: 1.4rem;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
}
.picker-content {
  display: flex;
  justify-content: space-around;
  /deep/ .van-picker {
    width: 33.3%;
  }
}
.save-btn-edit {
  position: fixed;
  top: 2.2rem;
  right: 1.6rem;
  z-index: 11;
  font-family: PingFangSC-Regular;
  font-size: 1.6rem;
  color: #a9936b;
  letter-spacing: 0;
  text-align: center;
  line-height: 1.6rem;
}
.delete-edit {
  width: 100%;
  background: #fff;
  height: 5rem;
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #fe5845;
  letter-spacing: 0;
  text-align: left;
  line-height: 5rem;
  padding-left: 1.6rem;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/person/addressEdit.vue